import { Fragment } from 'react/jsx-runtime'
import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription } from '@/shared/components/ui/alert'

export default function StrategiesHeader({ hasError }: { hasError: boolean }) {
	const { t } = useTranslation()

	return (
		<Fragment>
			{hasError && (
				<Alert variant='destructive' className='mt-2'>
					<AlertDescription>
						{t('anchoring_management.strategy_page.table.error')}
					</AlertDescription>
				</Alert>
			)}
			<h3 className='text-base font-semibold'>{t('entity.anchor_strategy')}</h3>
		</Fragment>
	)
}
